
export const KarmaPoolSubscriptionDetailsManager = (local, setLocal, getURLBasePath) => {

    function updateSubscriptionDetails() {
        fetch(getURLBasePath() + 'activeSubscriptionDetails',
        {
            method: 'GET',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json',
            }),
        })
        .then((response) => response.json())
        .then((data) => {
            console.log(data);
            // replace cycle on local as object
            setLocal(prevValue => {
                return { ...prevValue, subscriptionDetails: { ...data, loading: false } };
            });

            localStorage.setItem("local.cycle", JSON.stringify(data));
        })
        .catch((err) => {
            console.log(err.message);
        });
    }

    function cancelMembership() {
        
    }

    return {
        updateSubscriptionDetails
    };
}